import { useEffect, useState } from 'react';

const KIND_LABEL = {
  create: 'ساخت', edit: 'ویرایش', archive: 'بایگانی',
  restore: 'بازگردانی', merge: 'ادغام', revert: 'بازگشت',
};

export default function NoteHistoryModal({ note, agent, onClose, onChanged }) {
  const [revisions, setRevisions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { revisions: rows } = await agent.api.listRevisions(note.id);
        setRevisions(rows);
      } catch (e) { /* surfaced via agent.error elsewhere */ }
      setLoading(false);
    })();
  }, [note.id, agent.api]);

  const revert = async (revisionId) => {
    await agent.api.revertNote(note.id, revisionId);
    await onChanged();
    onClose();
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <h3 style={{ marginTop: 0 }}>تاریخچهٔ نت</h3>
        {loading && <div className="consultant-empty">در حال بارگذاری…</div>}
        {!loading && revisions.length === 0 && <div className="consultant-empty">تاریخچه‌ای نیست.</div>}
        {revisions.map((r) => (
          <div className="rev-row" key={r.id}>
            <div>
              <strong>{KIND_LABEL[r.change_kind] || r.change_kind}</strong>
              <div style={{ color: '#475569', marginTop: 4 }}>{r.content_snapshot}</div>
              <div style={{ color: '#64748b', fontSize: 11, marginTop: 3 }}>
                {new Date(r.changed_at).toLocaleString('fa-IR')}{r.reason ? ` · ${r.reason}` : ''}
              </div>
            </div>
            <button className="consultant-btn secondary" onClick={() => revert(r.id)}>بازگشت به این نسخه</button>
          </div>
        ))}
        <button className="consultant-btn secondary" style={{ marginTop: 10 }} onClick={onClose}>بستن</button>
      </div>
    </div>
  );
}
